<template id="BP">
  <!--<div id="BP_pic">
    <img src="../../../static/images/BP1.jpg"  style="width:190px;height:315px;">
    <img src="../../../static/images/BP2.jpg"  style="width:190px;height:315px;">
    <img src="../../../static/images/BP3.jpg"  style="width:190px;height:315px;">
    <img src="../../../static/images/BP4.jpg"  style="width:190px;height:315px;">
    <span>变频柜</span>
  </div>-->
  <div class="htmleaf-container">
    <Viewer :images="images">
      <img v-for="src in images" :src="src.url" :key="src">
    </Viewer>
    <div class="container gallery-container">
      <h1>变频柜</h1>
      <!-- <p class="page-description text-center">Thumbnails With Title And Description</p>-->
      <div class="tz-gallery">
        <div class="row images" v-viewer>
          <div class="col-sm-6 col-md-3">
            <div class="thumbnail">
              <img src="../../static/images/BP1.jpg" alt="BP1">
            </div>
          </div>
          <div class="col-sm-6 col-md-3">
            <div class="thumbnail">
              <img src="../../static/images/BP2.jpg" alt="BP2">
            </div>
          </div>
          <div class="col-sm-6 col-md-3">
            <div class="thumbnail">
              <img src="../../static/images/BP3.jpg" alt="BP3">
            </div>
          </div>
          <div class="col-sm-6 col-md-3">
            <div class="thumbnail">
              <img src="../../static/images/BP4.jpg" alt="BP4">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import 'viewerjs/dist/viewer.css'
import { ref, onMounted } from 'vue';
import { defineCustomElement } from 'vue';
import Viewer from 'v-viewer';
import baguetteBox from '../../static/js/baguetteBox.min.js';

// 注册 Viewer 组件
const ViewerComponent = defineCustomElement(Viewer);
customElements.define('v-viewer', ViewerComponent);

// 定义响应式数据
const images = ref(' ');

// 定义 mounted 生命周期钩子
onMounted(() => {
  ready();
});

// 定义方法
const ready = () => {
  baguetteBox.run('.tz-gallery');
};
</script>

<style scoped>
.gallery-container h1 {
  text-align: center;
  margin-top: 70px;
  font-family: 'Droid Sans', sans-serif;
  font-weight: bold;
  color: #58595a;
}

.gallery-container p.page-description {
  text-align: center;
  margin: 30px auto;
  font-size: 18px;
  color: #85878c;
}

.tz-gallery {
  padding: 40px;
}

.tz-gallery .thumbnail {
  padding: 0;
  margin-bottom: 30px;
  border-radius: 4px;
  border: none;
  transition: 0.15s ease-in-out;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.06);
}

.tz-gallery .thumbnail:hover {
  transform: translateY(-10px) scale(1.02);
}

.tz-gallery .lightbox img {
  border-radius: 4px 4px 0 0;
}

.tz-gallery .caption {
  padding: 26px 30px;
  text-align: center;
}

.tz-gallery .caption h3 {
  font-size: 14px;
  font-weight: bold;
  margin-top: 0;
}

.tz-gallery .caption p {
  font-size: 12px;
  color: #7b7d7d;
  margin: 0;
}

.baguetteBox-button {
  background-color: transparent !important;
}

.thumbnail img {
  width: 224px;
  height: 300px;
}

@media (min-width: 768px) {
  .thumbnail img {
    width: 120px;
    height: 240px;
  }

  @media (min-width: 1360px) {
    .thumbnail img {
      width: 220px;
      height: 280px;
    }
  }
}
</style>